export default __webpack_public_path__ + "static/media/penguin svn.1ec30fd1.png";